<template>
  <div class="qkxx fifth" v-if="CommentList">
    <form class="form-horizontal fifth" ref="from">
      <div class="advice_text"><strong>Comment</strong></div>
      <div class="ten">
        <span>Current User：{{ NickyName }}</span>
        <span class="ml15">
          <el-checkbox v-model="checked">Anonymous</el-checkbox>
        </span>
      </div>
      <div class="form-group">
        <div class="col-sm-12 ten">
          <el-form ref="form">
            <el-form-item>
              <el-input
                type="textarea"
                placeholder="Input comments please"
                :rows="5"
                v-model="commentText"
              ></el-input>
              <el-button
                type="primary"
                @click="publishComment(commentText)"
                class="ten"
                >Submit</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </form>
    <div class="advice_text">
      Total
      <strong class="red">{{ comms == 0 ? comm : comms }}&nbsp;</strong>Comments
      <el-button
        v-if="CommentList.length > 2"
        type="primary"
        @click="tocom($event, id)"
        >More</el-button
      >

      <span class="red ml5" style="font-size: 13px" v-show="Token == ''"
        >Sign in to comment。</span
      >
    </div>
    <div class="media advice_list" v-if="CommentList.length > 0">
      <div
        class="media-body fifth"
        v-for="(item, index) in CommentLists.length < 1
          ? CommentList
          : CommentLists"
        :key="index"
      >
        <div class="media-heading">
          <span v-if="item.IfNickyName == true">Anonymous</span>
          <span v-else>{{ item.CommentatorName }}</span>
          <span class="media-date">{{ item.DateCreate }}</span>
        </div>
        <div class="five">{{ item.Comment }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      commentText: '', // 评论内容
      NickyName: '',
      checked: false,
      commentText: '',
      Token: '',
      CommentLists: '',
      comms: 0,
    }
  },
  props: ['comm', 'CommentList', 'Kind'],
  mounted() {
    this.id = this.$route.query.ArticleID
      ? this.$route.query.ArticleID
      : this.$route.query.ItemId
    var a = localStorage.getItem('userInfo')
    if (a != null) {
      this.Token = JSON.parse(a).Token
      this.NickyName = JSON.parse(a).UserName
    }
  },
  methods: {
    publishComment(e) {
      this._postMassage()
      this._getPLLB(this.id)
    },
    _postMassage() {
      var id = parseInt(this.id)
      var Text = this.commentText
      var Ip = returnCitySN['cip']
      var title = this.Title
      var name = this.checked
      if (this.Token == '') {
        alert('Sign in to comment')
        return
      }
      let params = {
        Token: this.Token,
        Kind: this.Kind,
        ID: id,
        IfNickyName: name,
        Comments: Text,
        IpAddress: Ip,
        Title: title,
      }
      // var a = sessionStorage.getItem('aa')
      // if (a == 1) {
      //   params.Kind = 4
      // } else {
      //   params.Kind = 2
      // }
      this.$store
        .dispatch('_postMassage', params)
        .then((res) => {
          if (res.data.IsSuccess) {
            alert('Successfully published')
            var cc = this.checked
            sessionStorage.setItem('cc', cc)
            this._getPLLB()
            this.commentText = ''
          }
        })
        .catch((err) => {
          alert(this.$CHEn.CH_EN(res.data.Message))
          console.log('err', err)
        })
    },
    _getPLLB(id) {
      var id = id
      let params = {
        Type: 2,
        ID: id,
        PageSize: 3,
      }
      var a = sessionStorage.getItem('aa')
      if (a == 1) {
        params.Type = 4
      } else {
        params.Type = 2
      }
      this.$store
        .dispatch('_getPLLB', params)
        .then((res) => {
          if (res.data.IsSuccess) {
            this.CommentLists = res.data.Data
            this.comms = res.data.ItemCount
          }
        })
        .catch((err) => {
          console.log('err', err)
        })
    },
    tocom(e, id) {
      e.preventDefault()
      this.$router.push({
        path: "/comments",
        query: { ArticleID: id },
      })
    },
  },
}
</script>
